import { TrackedEvents } from '../../../features/tracking';
import { useTrack } from '../../../hooks/useTrack';
import { PhotoCaptureTimer } from './photoCaptureTimer';
import { type PhotoCaptureRequestStatus } from '../../../services/photoCapture';

const updatePhotoCaptureTimer = (status: PhotoCaptureRequestStatus): void => {
  switch (status) {
    case 'requested': {
      PhotoCaptureTimer.start(status, Date.now());
      break;
    }
    case 'rejected':
    case 'uploaded':
    case 'error': {
      PhotoCaptureTimer.finish(status);
      break;
    }
    default: {
      PhotoCaptureTimer.step(status);
    }
  }
};

type PhotoCaptureEvents = {
  sendPhotoCaptureStartedEvent: () => void;
  sendPhotoCapturePhotoTakenEvent: () => void;
  sendPhotoCaptureRetakeClickedEvent: () => void;
  sendPhotoCaptureDownloadClickedEvent: () => void;
  updatePhotoCaptureTimer: (status: PhotoCaptureRequestStatus) => void;
};

export const usePhotoCaptureEvents = (): PhotoCaptureEvents => {
  const track = useTrack();

  const sendPhotoCaptureStartedEvent = (): void => {
    void track(TrackedEvents.PhotoCaptureStarted, {});
  };

  const sendPhotoCapturePhotoTakenEvent = (): void => {
    void track(TrackedEvents.PhotoCapturePhotoTaken, {});
  };

  const sendPhotoCaptureRetakeClickedEvent = (): void => {
    void track(TrackedEvents.PhotoCaptureRetakeClicked, {});
  };

  const sendPhotoCaptureDownloadClickedEvent = (): void => {
    void track(TrackedEvents.PhotoCaptureDownloadClicked, {});
  };

  return {
    sendPhotoCaptureStartedEvent,
    sendPhotoCapturePhotoTakenEvent,
    sendPhotoCaptureRetakeClickedEvent,
    sendPhotoCaptureDownloadClickedEvent,
    updatePhotoCaptureTimer,
  };
};
